export default __webpack_public_path__ + "static/media/bussiness_tutorial_n.cbcaf7b7.svg";